module.exports = __webpack_public_path__ + "static/media/leg_press_machine.6c57dc39.png";